import { render } from "./Usulan.vue?vue&type=template&id=41cd574e"
import script from "./Usulan.vue?vue&type=script&lang=js"
export * from "./Usulan.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__